import { createSlice, PayloadAction as Payload } from '@reduxjs/toolkit';
import { Language } from '../../types/enums';

interface SettingsState {
  language: Language;
  rigiLanguage: string;
}

const initialState: SettingsState = {
  language: Language.EN,
  rigiLanguage: ""
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateLanguage: (state: any, action: Payload<string>) => {
      return {
        ...state,
        language: action.payload,
      }
    },
    updateRigiLanguage: (state: any, action: Payload<string>) => {
      return {
        ...state,
        rigiLanguage: action.payload,
      }
    },
  },
});

export default settingsSlice;